module.exports = __webpack_public_path__ + "img/mobile-phone.b8701496.svg";